import { render, staticRenderFns } from "./ClipTool.vue?vue&type=template&id=3db5a260&scoped=true"
import script from "./ClipTool.vue?vue&type=script&lang=js"
export * from "./ClipTool.vue?vue&type=script&lang=js"
import style0 from "./ClipTool.vue?vue&type=style&index=0&id=3db5a260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db5a260",
  null
  
)

export default component.exports